export default __webpack_public_path__ + "static/media/git.fb0e94ce.png";